import MessageReceiver from './MessageReceiver';
import './style/index.less';

export default MessageReceiver;
